module.exports = __webpack_public_path__ + "media/images/gallery/constellations/orion/ori_dir-38751bb6795b6c086702805e541e06de.gif";